<!--工人详情页-资格证书-->
<template>
  <div>
    <div v-if="newData && newData.length">
      <div class="experiences" v-for="(item, index) in newData" :key="index">
        <div  class="item_experience">
          <div class="item_adres">
            <h3 style="min-width:20px">{{ item.workName }}</h3>
            <div class="timer" style="margin-left: 10px;color: #333333;font-size: 14px;line-height: 23px;">
                {{item.certificateTime? dateFormat(item.certificateTime): ""}}
            </div>
            <div class="certified">已认证</div>
            <el-popover effect trigger="hover" placement="bottom" :offset="150" close-delay='100' popper-class="renzheng-tishi"  content="该证书已通过经营帮平台官方审核认证(人工核对-人力资源和社会保障部-技能人才评价证书联网查询)">
              <span slot="reference" class="certifiedTips"><img style="width:16px;height:16px; vertical-align: middle;"  src="@/assets/team/tishi.png" alt=""></span>
            </el-popover>
          </div>
          <el-row :gutter="20" >
            <el-col>
              <div class="item_flex">
                <div class="flex_title">
                  <span>证书图片：</span>
                </div>
                <el-image class="item_pic" :src="item.coverPhoto" :preview-src-list="[item.coverPhoto]" fit="cover"></el-image>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.customFieldListVo && item.customFieldListVo.length">
            <el-col
                :span="24"
                class="detail-item"
                v-for="(field, index) in item.customFieldListVo"
                :key="index"
              >
                <span class="item-name">{{ field.name }}：</span>
                <span class="item-value">{{ field.content }}</span>
            </el-col>
          </el-row>
        </div>
      </div>
       <BaseEmptyData
        isDetail
        v-if="!(newData && newData.length)"
      ></BaseEmptyData>
    </div>
    <div v-else>
      <div class="experiences" v-for="(item, index) in data" :key="index">
          <div class="item_experience">
            <div class="item_adres">
              <h3 style="min-width:20px">{{ item.name }}</h3>
              <div class="timer" style="margin-left: 10px;color: #333333;font-size: 14px;line-height: 23px;">
                {{item.collectionTime? dateFormat(item.collectionTime): ""}}
              </div>
            </div>
            <el-row :gutter="20" v-if="item.url.length > 0">
              <el-col>
                <div class="item_flex">
                  <div class="flex_title">
                    <span>证书图片：</span>
                  </div>
                  <el-image
                    class="item_pic"
                    v-for="(item, index) in item.url"
                    :key="index"
                    :src="item"
                    :preview-src-list="[item]"
                    fit="cover"
                  ></el-image>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="item.certificateFieldList && item.certificateFieldList.length">
              <el-col
                :span="24"
                class="detail-item"
                v-for="(field, index) in item.certificateFieldList"
                :key="index"
              >
                <span class="item-name">{{ field.name }}：</span>
                <span class="item-value">{{ field.content }}</span>
              </el-col>
            </el-row>
          </div>
      </div>
       <BaseEmptyData
        isDetail
        v-if="!(data && data.length)"
      ></BaseEmptyData>
    </div>
  </div>
</template>

<script>
export default {
  name: "qualification",
  props: {
    data: {
      type: Array,
      default: []
    },
    //2.4.0新资格证书
    newData: {
      type: Array,
      default: []
    }
  },
  data() {
    return {}
  },
  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData") // 暂无数据缺省图
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.leftBox {
  .workerDetail_tab {
    .experiences {
      padding: 15px;
      background: #f5f7fa;
      margin-bottom: 10px;
      :nth-child(2n) {
        margin-right: 0;
      }
      .item_experience {
        .item_adres {
          display: flex;
          padding-bottom: 10px;
          .timer {
            font-size: 16px;
            // font-weight: bold;
          }
          .certified{
              margin-left: 10px;
              background: #e2efe4;
              font-size: 12px;
              padding: 4px 6px;
              color:#78C06E;
            }
            .certifiedTips{
              margin-left: 5px;
              cursor: pointer;
            }
        }
        .detail-item {
          display: flex;
          padding-top: 10px;
          line-height: 22px;
          .item-name {
            flex-wrap: wrap;
            max-width: 162px;
            flex-shrink: 0;
            color: var(--FC6);
          }
          .item-value {
            color: var(--FC3);
            .item-video {
              position: relative;
              display: inline-block;
              width: 150px;
              height: 100px;
              cursor: pointer;
              > video {
                width: 100%;
                height: 100%;
              }
              &:before {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(calc(-50% + 10px), -50%);
                border: solid;
                border-width: 10px 15px;
                border-color: transparent transparent transparent #fff;
              }
            }
          }
        }
      }
      .item_flex {
        display: flex;
        line-height: 22px;
        .flex_title {
          width: 70px;
        }
        .item_tag {
          flex: 1;
        }
        .item_pic {
          margin-right: 10px;
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.renzheng-tishi[x-placement^=bottom] {
  background: #000;
  opacity: 0.5;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  padding: 0 10px;
  height: 22px;
  line-height: 20px;
  border: none;
  & .popper__arrow::after {
    border-bottom-color: #000!important;
  }
}
</style>